import React, { Fragment } from 'react';
import strings from '../../../assets/localization';
import Alert from './Alert';
import Button from '../Button/Button';
import FakeBackground from '../../TopIndex/FakeBackground';

export const ErrorFallback = () => {
  const reloadPage = () => {
    location.reload();
  };

  return (
    <Fragment>
      <FakeBackground />
      <Alert>
        <h1>{strings.whoops}!</h1>
        <p>{strings.somethingWentWrong} ...</p>
        <Button clicked={reloadPage}>{strings.tryAgain}</Button>
      </Alert>
    </Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/UI/Alert/ErrorFallback.js